export default "__VITE_ASSET__CWd41Pkq__"